import React from "react";
import { RiBallPenLine } from "react-icons/ri";
import { MdDelete } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { TbMenu2 } from  "react-icons/tb";
import { IoMdArrowDropdown } from "react-icons/io";

import {
  removeCoordinate,
  updateCoordinateName,
  updateCoordinateSignatory,
  updateCoordinateIsRequired,
} from "../../utils/updateCoordinates";
import { setSignatureCoordinates } from "../../redux/slices/signatureCoordinatesReducer";
import { setActiveCoordinate } from "../../redux/slices/activeCoordinateReducer";
import CustomSelect from "../../components/custom-select";
import CustomToggle from "../../components/custom-toggle";

function SelectedSignatureContainer({}) {
  const dispatch = useDispatch();
  const activeCoordinate = useSelector(
    (state) => state.activeCoordinate.activeCoordinate
  );
  const signatoryList = useSelector(
    (state) => state.signatoryList.signatoryList
  );
  const signatureCoordinates = useSelector(
    (state) => state.signatureCoordinates.signatureCoordinates
  );

  const handleEleDelete = () => {
    const updatedCoords = removeCoordinate(
      signatureCoordinates,
      activeCoordinate.eleId
    );
    dispatch(setSignatureCoordinates({ signatureCoordinates: [] }));
    setTimeout(() => {
      dispatch(
        setSignatureCoordinates({ signatureCoordinates: updatedCoords })
      );
    }, 0);
    dispatch(
      setActiveCoordinate({ activeCoordinate: {}, isSelectionMode: false })
    );
  };

  const handleCurrentCoordSignatoryChange = (e) => {
    dispatch(
      setSignatureCoordinates({
        signatureCoordinates: updateCoordinateSignatory(
          signatureCoordinates,
          activeCoordinate.eleId,
          e.id,
          e.index,
          e.bgColor
        ),
      })
    );

    const updatedActiveCoordinates = {
      ...activeCoordinate,
      signatory_id: e.id,
      user_index_id: e.index,
      bgColor: e.bgColor,
    };
    dispatch(
      setActiveCoordinate({
        activeCoordinate: updatedActiveCoordinates,
        isSelectionMode: true,
      })
    );
  };

  const handleCurrentCoordNameChange = (e) => {
    const name = e.target.value;
    dispatch(
      setSignatureCoordinates({
        signatureCoordinates: updateCoordinateName(
          signatureCoordinates,
          activeCoordinate.eleId,
          name
        ),
      })
    );

    const updatedActiveCoordinates = {
      ...activeCoordinate,
      name: name,
    };
    dispatch(
      setActiveCoordinate({
        activeCoordinate: updatedActiveCoordinates,
        isSelectionMode: true,
      })
    );
  };

  const handleCurrentCoordIsRequiredChange = (value) => {
    dispatch(
      setSignatureCoordinates({
        signatureCoordinates: updateCoordinateIsRequired(
          signatureCoordinates,
          activeCoordinate.eleId,
          value
        ),
      })
    );

    const updatedActiveCoordinates = {
      ...activeCoordinate,
      isRequired: value,
    };
    dispatch(
      setActiveCoordinate({
        activeCoordinate: updatedActiveCoordinates,
        isSelectionMode: true,
      })
    );
  };
  
  const [dropdown,setDropdown]=useState(true);
  
  const toggleDropdown = () => {
    setDropdown(!dropdown);
  };

  return (
    <>
    
    <div className="right-sidebar-tool-detail-mobile">
      <div className="right-sidebar-tool-header">
        <div style={{alignSelf:"center", marginLeft:"28px", marginTop :"3px"}}>
          <RiBallPenLine
            style={{ color: "#555d65", margin: "0px 5px -3px 0px" }}
          />
          <span
            style={{
              fontSize: "12px",
              color: "#555d65",
            }}
          >
            SIGNATURE
          </span>
        </div>
        <MdDelete
          style={{
            cursor: "pointer",
        backgroundColor: "red",
        padding: "5px",
        borderRadius: "100%",
        fontSize: "16px",
        marginRight: "50px",
        color: "white",
          }}
          onClick={handleEleDelete}
        />
      </div>
      {dropdown && (
        <>  
      <div className="right-sidebar-section">
        <label htmlFor="currentCoordSigner" className="field-lbl">
          Assigned to
        </label>
        <div>
          <CustomSelect
            value={signatoryList.find(
              (signatory) => signatory.id === activeCoordinate.signatory_id
            )}
            name="currentCoordSigner"
            options={signatoryList}
            onChange={(e) => {
              handleCurrentCoordSignatoryChange(e);
            }}
          ></CustomSelect>
        </div>
      </div>

      {/* <div key={activeCoordinate.name} className="right-sidebar-section">
        <label className="field-lbl">
          Name<span style={{ color: "red" }}>*</span>
        </label>
        <input
          defaultValue={activeCoordinate.name}
          onChange={(event) => handleCurrentCoordNameChange(event)}
          className="input-field"
        />
      </div> */}

      <div
        style={{
          display: "flex",
          // flexDirection: "column",
          width:"100wv",
          justifyContent:"space-between"
        }}
        className="right-sidebar-section"
      >
        <CustomToggle
          title="Required"
          defaultValue={activeCoordinate.isRequired}
          onChange={(value) => {
            handleCurrentCoordIsRequiredChange(value);
          }}
        />
      </div>
      <hr style={{marginTop:"5px"}} />
      </>
    )}
    <div className="mobile-dropdown" style={{ marginTop: "4px"}}>
        <div onClick={toggleDropdown} className="dropdown-toggle-btn">
          < IoMdArrowDropdown

    
            style={{
              margin: "10px",
              marginTop : "16px",
              position : "absolute",
              top : "0",
              fontSize : "x-large",
              left : "0",
              padding: "0px",
              // backgroundColor: "#4D4D4D",
              color: "black",
              borderRadius: "100%",
              // fontSize: "medium",
            }}
          />
        </div>
      </div>
    </div>
    <div className="right-sidebar-tool-detail-desktop">
      <div className="right-sidebar-tool-header">
        <div>
          <RiBallPenLine
            style={{ color: "#555d65", margin: "0px 5px -3px 0px" }}
          />
          <span
            style={{
              fontSize: "16px",
              color: "#555d65",
            }}
          >
            SIGNATURE
          </span>
        </div>
        
      </div>

      <div className="right-sidebar-section">
        <label htmlFor="currentCoordSigner" className="field-lbl">
          Assigned to
        </label>
        <div >
          <CustomSelect
            value={signatoryList.find(
              (signatory) => signatory.id === activeCoordinate.signatory_id
            )}
            name="currentCoordSigner"
            options={signatoryList}
            onChange={(e) => {
              handleCurrentCoordSignatoryChange(e);
            }}
          ></CustomSelect>
        </div>
      </div>

      {/* <div key={activeCoordinate.name} className="right-sidebar-section">
        <label className="field-lbl">
          Name<span style={{ color: "red" }}>*</span>
        </label>
        <input
          defaultValue={activeCoordinate.name}
          onChange={(event) => handleCurrentCoordNameChange(event)}
          className="input-field"
        />
      </div> */}

      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
        className="right-sidebar-section"
      >
        <CustomToggle
          title="Required"
          defaultValue={activeCoordinate.isRequired}
          onChange={(value) => {
            handleCurrentCoordIsRequiredChange(value);
          }}
        />
        <button onClick={handleEleDelete} style={{
                      cursor: "pointer",
                      fontSize: "small",
                      marginRight: "0px",
                      color: "#ffffff",
                      backgroundColor:'#4d4d4d',
                      borderRadius:'5px',
                      position:'absolute',
                      bottom : '-49px',
                      border:'0',
                      shadown:'0',
                      alignItems:'center',
                      alignSelf:'center',
                      right:'50%',
                      padding:'8px',
                      marginTop:'10px',
                      width:'40%',
                      display:'flex',
                      zIndex:'0'
                    }}>
                  <MdDelete
                    
                    
                  />
                  
                  DELETE
                  </button>
      </div>
    </div>
    </>
  );
}

export default SelectedSignatureContainer;
